import { Session } from '@supabase/supabase-js'
import { atom } from 'recoil'

const sessionStorage = atom<Session | null>({
  key: 'Session',
  default: null,
})
export default sessionStorage
